export function formatBidNumber(bidNumber, revisionNumber) {
  if (!bidNumber) return '';
  return revisionNumber > 1 ? `${bidNumber}-R${revisionNumber - 1}` : bidNumber;
}

// Standalone revision label for a stored RevisionNumber (original = 1, first
// revision = 2, …): 'Original' for the base version, then 'R1', 'R2', …
export function formatRevLabel(revisionNumber) {
  return revisionNumber > 1 ? `R${revisionNumber - 1}` : 'Original';
}
